(function () {
    'use strict';

    angular
        .module('telestatApp')
        .config(['uibDatepickerPopupConfig', function(uibDatepickerPopupConfig) {
            uibDatepickerPopupConfig.closeText = 'Закрыть';
            uibDatepickerPopupConfig.clearText = 'Очистить';
            uibDatepickerPopupConfig.currentText = 'Сегодня';
        }]);

})();


